import { MappaBaseService } from './mappa-base.service';
import { EventEmitter, Injectable, OnDestroy } from '@angular/core';

import { Layer, Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
import BaseLayer from 'ol/layer/Base';
import { OSM, TileWMS, Vector as VectorSource, XYZ } from 'ol/source';
import Feature from 'ol/Feature';
import { Circle, Point, Polygon } from 'ol/geom';
import GeoJSON from 'ol/format/GeoJSON';
import { Circle as CircleStyle, Fill, Icon, Stroke, Style, Text } from 'ol/style';

import { Draw, Modify, Snap } from 'ol/interaction';
import { transform } from 'ol/proj';

import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { reject } from 'q';
import { BehaviorSubject, Subject } from 'rxjs';
import GeometryType from 'ol/geom/GeometryType';
import IconAnchorUnits from 'ol/style/IconAnchorUnits';
import { MapComponent } from 'src/app/library/ebw-map-angular/map.component';
import { MapService, PosizioneLayer, TipoLayer } from 'src/app/library/ebw-map-angular/service/map.service';

@Injectable({
   providedIn: 'root'
})
export class MappaService extends MappaBaseService implements OnDestroy {

   NUOVA_POSIZIONE_KEY = 'nuovaPosizione';
   AGGIUNGI_LAYER_KEY = 'aggiungiLayer';
   ELIMINA_LAYER_KEY = 'eliminaLayer';
   AGGIUNGI_INTERAZIONE_KEY = 'aggiungiInterazione';
   ELIMINA_INTERAZIONE_KEY = 'eliminaInterazione';
   SELEZIONE_FEATURES_KEY = 'attivaSelezione';
   OGGETTI_SELEZIONATI_KEY = 'oggettiSelezionati';
   CAMBIATO_BASE_LAYER_KEY = 'cambiatoBaseLayer';
   NASCONDI_LAYER = 'nascondiLayer';
   MOSTRA_LAYER = 'mostraLayer';
   CAMBIATA_RAPPRESENTAZIONE = 'cambiataRappresentazione';
   REFRESH_MAPPA = 'refreshMappa';

   public mappa: MapComponent;

   selezioneFeatures: Boolean = Boolean(false);
   selezioneFeauresLayer: VectorLayer;

   disegnoLibero = false;
   disegnoLiberoLayer: VectorLayer;
   disegnoLiberoSource!: VectorSource;
   disegnoLiberoModify!: Modify;
   disegnoLiberoDraw!: Draw;
   disegnoLiberoSnap!: Snap;

   localizzazioneAttiva = false;
   localizzatoreId!: number;
   posizioneFeature: Feature;
   accuratezzaFeature: Feature;
   localizzazioneLayer: VectorLayer;

   layerBaseAttivo!: string;
   rappresentazioneAttiva: BaseLayer;
   tipologiaUtenteCorrente = 'operatore';

   eventoGenerico: EventEmitter<{ chiave: string, valore: object }> = new EventEmitter();

   // Questo subject viene utilizzato dal router per poter passare i dati alla mappa quando ci si trova già in quella rotta
   updateDataWithSameRoute: BehaviorSubject<any> = new BehaviorSubject<any>('');

   /** Per chiudere la sidebar */
   //toggleSidebar: Subject<boolean> = new Subject<boolean>();
   toggleSidebar: Subject<any> = new Subject<any>();

   /** Per chiudere il tool disegno da analysis edit area */
   chiudiToolDisegno: Subject<boolean> = new Subject<boolean>();

   /** Per illuminare le features */
   illuminaFeatureSub: Subject<any> = new Subject<any>();

   /** Per spegnere le features */
   spegniFeatureSub: Subject<any> = new Subject<any>();

   /** Per Aprire Google Street View da un qualunque componente del portale */
   toggleStreetViewSubject: Subject<any> = new Subject<any>();

   /** Per Nascondere/Mostrare il pulsante di Google Street View */
   isStreetViewVisibleSubject: Subject<boolean> = new Subject<boolean>();

   /** Per modificare la dimensione della right sidebar - value: 'large' || 'small' */
   setRightSidebarWidthSubject: Subject<string> = new Subject<string>();

   mapReady: BehaviorSubject<boolean> = new BehaviorSubject<any>(false);

   // Subject per aprire il tool di disegno da un componente esterno alla mappa
   gestisciToolDisegnoSubject: Subject<any> = new Subject<any>();
   // Subject per chiudere il tool di disegno da un componente esterno alla mappa
   chiudiToolDisegnoSubjectExtSubject: Subject<boolean> = new Subject<boolean>();
   // Subject per restituire la geometria disegnata con il tool di disegno ad un componente esterno alla mappa
   drawingToolFeaturesSubject: Subject<any> = new Subject<any>();

   constructor(private http: HttpClient, private configService: ConfigService) {
      super();

      this.posizioneFeature = new Feature();
      const style = new Style({
         image: new Icon({
            anchor: [0.5, 1],
            anchorXUnits: IconAnchorUnits.FRACTION,
            anchorYUnits: IconAnchorUnits.FRACTION,
            src: 'assets/icons/position.png'
         })
      });
      this.posizioneFeature.setStyle(style);

      this.accuratezzaFeature = new Feature({
         style: new Style({
            image: new CircleStyle({
               radius: 5,
               fill: new Fill({
                  color: 'rgba(255, 255, 255, 0.5)'
               }),
               stroke: new Stroke({
                  color: '#3399CC',
                  width: 2
               })
            })
         })
      });

      this.localizzazioneLayer = new VectorLayer({
         source: new VectorSource(),
         visible: false
      });
      this.localizzazioneLayer.set('generic_type', 'TEMP');
      this.localizzazioneLayer.set('user_type', 'cittadino_operatore');
      this.aggiungiNuovoLayerGenerico('posizione_utente', this.localizzazioneLayer);

      this.selezioneFeauresLayer = new VectorLayer({
         visible: false
      });
      this.selezioneFeauresLayer.set('generic_type', 'TEMP');
      this.selezioneFeauresLayer.set('user_type', 'cittadino_operatore');
      this.aggiungiNuovoLayerGenerico('selezione_features', this.selezioneFeauresLayer);

      this.disegnoLiberoLayer = new VectorLayer({
         visible: false
      });
      this.disegnoLiberoLayer.set('generic_type', 'TEMP');
      this.disegnoLiberoLayer.set('user_type', 'cittadino_operatore');
      this.aggiungiNuovoLayerGenerico('disegno_libero', this.disegnoLiberoLayer);
   }

   inizializzaMappa() {
      this.configService.getConfigMappa().wmsLayers.forEach((item) => {
         this.aggiungiNuovoWMSLayerDaConfig(item);
      });
   }

   ngOnDestroy(): void {
      if (this.localizzazioneAttiva) {
         navigator.geolocation.clearWatch(this.localizzatoreId);
         this.localizzazioneAttiva = false;
         this.localizzazioneLayer.setVisible(false);
         this.localizzazioneLayer.getSource().clear();
      }
   }

   controllaTipologiaUtente(): boolean {
      // console.log('controllaTipologiaUtente: ' + this.tipologiaUtenteCorrente);
      return this.tipologiaUtenteCorrente === 'operatore';
   }

   aggiungiNuovoBaseLayerDaConfig(JSONlayer) {
      const layer: TileLayer = new TileLayer();
      let source;
      switch (JSONlayer.title) {
         case 'Open Street Map':
            layer.setSource(new OSM());
            break;
         // case 'ExampleWMS':
         //    source = new TileWMS({
         //       url: JSONlayer.url,
         //       params: JSONlayer.params,
         //       transition: 0 // Durata dell'effetto di opacità durante la transizione
         //    });
         //    layer.setSource(source);
         //    break;
         // case 'ExampleXYZ':
         //    source = new XYZ({
         //       url: JSONlayer.url
         //    });
         //    layer.setSource(source);
         //    break;
         default:
            break;
      }
      layer.setOpacity(JSONlayer.opacity);
      layer.setVisible(JSONlayer.visible);
      layer.set('map_type', JSONlayer.map_type);
      layer.set('generic_type', 'BASE');
      layer.set('user_type', JSONlayer.user_type);
      if (JSONlayer.visible) {
         this.layerBaseAttivo = JSONlayer.title;
      }

      this.aggiungiNuovoLayerGenerico(JSONlayer.title, layer);
   }

   aggiungiNuovoWMSLayerDaConfig(JSONlayer) {
      let source;

      source = new TileWMS({
         url: JSONlayer.url,
         params: JSONlayer.params,

         transition: 0, // Durata dell'effetto di opacità durante la transizione
         cacheSize: 0
      });

      const layer = new TileLayer({
         source: source,
         opacity: JSONlayer.opacity,
         visible: JSONlayer.visible,
         maxResolution: JSONlayer.maxResolution
      });
      layer.set('generic_type', 'WMS');
      layer.set('group_id', JSONlayer.group_id);
      layer.set('tab', JSONlayer.tab);
      layer.set('user_type', JSONlayer.user_type);

      if (JSONlayer.visible && JSONlayer.tab === 'Base') {
         this.rappresentazioneAttiva = layer;
      }

      this.aggiungiNuovoLayerGenerico(JSONlayer.title, layer);
   }

   private aggiungiNuovoLayerGenerico(nome: string, layer: BaseLayer) {
      layer.set('title', nome);
      this.layers.push(layer);
      this.eventoGenerico.emit({ chiave: this.AGGIUNGI_LAYER_KEY, valore: layer });
   }

   accendiSpegniTuttiLayerWMS(visibile: boolean) {
      this.layers.filter(this.isLayerWMS)
         .forEach(function (element) { element.setVisible(visibile); });
   }

   refreshMappa() {
      this.eventoGenerico.emit({ chiave: this.REFRESH_MAPPA, valore: null });
   }

   localizzami() {
      if (!this.localizzazioneAttiva) {
         if (navigator.geolocation) { // controllo se Geolocation è supportato dal broswer
            this.localizzatoreId = navigator.geolocation.watchPosition((position) => {

               if (!this.localizzazioneLayer.getVisible()) {

                  const coordinate = transform([position.coords.longitude, position.coords.latitude], this.EPSG_4326_KEY, this.EPSG_3857_KEY);

                  this.posizioneFeature.setGeometry(new Point(coordinate));
                  this.accuratezzaFeature.setGeometry(new Circle(coordinate, position.coords.accuracy));
                  this.localizzazioneLayer.setVisible(true);
                  this.localizzazioneLayer.getSource().addFeature(this.accuratezzaFeature);
                  this.localizzazioneLayer.getSource().addFeature(this.posizioneFeature);
                  this.eventoGenerico.emit({ chiave: this.NUOVA_POSIZIONE_KEY, valore: position });
               }
            });
         } else {
            console.log('Geolocalizzazione non riuscita oppure non supportata da questo browser.');
         }
         this.localizzazioneAttiva = true;
      } else {
         this.localizzazioneLayer.setVisible(false);
         this.localizzazioneLayer.getSource().clear(); // Remove all features from the source.

         // fermo la localizzazione
         navigator.geolocation.clearWatch(this.localizzatoreId);
         this.localizzazioneAttiva = false;
      }
   }

   disegnaLiberamente() {
      if (!this.disegnoLibero) {

         this.disegnoLiberoSource = new VectorSource();
         this.disegnoLiberoLayer.setSource(this.disegnoLiberoSource);
         this.disegnoLiberoLayer.setStyle(new Style({
            fill: new Fill({
               color: 'rgba(255, 255, 255, 0.2)'
            }),
            stroke: new Stroke({
               color: '#ffcc33',
               width: 2
            }),
            image: new CircleStyle({
               radius: 7,
               fill: new Fill({
                  color: '#ffcc33'
               })
            })
         }));

         this.disegnoLiberoModify = new Modify({ source: this.disegnoLiberoSource });
         this.disegnoLiberoSnap = new Snap({ source: this.disegnoLiberoSource });
         this.disegnoLiberoDraw = new Draw({
            source: this.disegnoLiberoSource,
            type: GeometryType.POINT
         });

         this.eventoGenerico.emit({ chiave: this.AGGIUNGI_INTERAZIONE_KEY, valore: this.disegnoLiberoModify });
         this.eventoGenerico.emit({ chiave: this.AGGIUNGI_INTERAZIONE_KEY, valore: this.disegnoLiberoDraw });
         this.eventoGenerico.emit({ chiave: this.AGGIUNGI_INTERAZIONE_KEY, valore: this.disegnoLiberoSnap });
         this.disegnoLibero = true;
         this.disegnoLiberoLayer.setVisible(true);

      } else {

         console.log('Punti disegnati ', this.disegnoLiberoLayer.getSource().getFeatures().length);
         this.disegnoLiberoLayer.getSource().clear();
         this.disegnoLibero = false;
         this.disegnoLiberoLayer.setVisible(false);

         this.eventoGenerico.emit({ chiave: this.ELIMINA_INTERAZIONE_KEY, valore: this.disegnoLiberoSnap });
         this.eventoGenerico.emit({ chiave: this.ELIMINA_INTERAZIONE_KEY, valore: this.disegnoLiberoDraw });
         this.eventoGenerico.emit({ chiave: this.ELIMINA_INTERAZIONE_KEY, valore: this.disegnoLiberoModify });
      }
   }

   disegnaGeoJSONObject(GeoJSONObject) {

      this.selezioneFeauresLayer.setSource(new VectorSource({
         features: (new GeoJSON()).readFeatures(JSON.parse(GeoJSONObject.toString()))
      })
      );
      this.eventoGenerico.emit({ chiave: this.OGGETTI_SELEZIONATI_KEY, valore: this.selezioneFeauresLayer });
   }

   attivaSelezione() {
      this.selezioneFeatures = Boolean(!this.selezioneFeatures.valueOf());

      if (this.selezioneFeauresLayer.getSource() !== undefined) {
         this.selezioneFeauresLayer.getSource().clear();
      }

      this.selezioneFeauresLayer.setVisible(this.selezioneFeatures.valueOf());
      this.eventoGenerico.emit({ chiave: this.SELEZIONE_FEATURES_KEY, valore: this.selezioneFeatures });
   }

   cambiaLayerBase(layer: BaseLayer) {
      if (layer.get('title') !== this.layerBaseAttivo) {
         this.layers.filter(function (item) {
            return item.get('generic_type') === 'BASE';
         })
            .forEach(function (element) {
               if (element.get('title') === layer.get('title')) {
                  // console.log(element);
                  element.setVisible(!element.getVisible());
               } else {
                  element.setVisible(false);
               }
            });
         this.eventoGenerico.emit({ chiave: this.CAMBIATO_BASE_LAYER_KEY, valore: layer });
         this.layerBaseAttivo = layer.get('title');
      }
   }

   cambiaRappresentazione(nuovoLayer: BaseLayer) {

      console.log('Cambia Rappresentazione', nuovoLayer);

      // Nascondo tutti i layer WMS del tab Base e quelli aggiuntivi e opzionali
      this.layers.filter(this.isLayerWMS).filter(this.isBaseTab).forEach(function (item) {
         item.setVisible(false);
      });

      // Nascondo tutti i layer WMS supporto
      this.layers.filter(this.isLayerWMS).filter(this.isLayerSupporto).forEach(function (item) {
         item.setVisible(false);
      });

      // Nascondo tutti i layer WMS opzionali
      this.layers.filter(this.isLayerWMS).filter(this.isLayerOzionale).forEach(function (item) {
         item.setVisible(false);
      });

      // Nascondo tutti i layer WMS vari che non fanno parte della rappresentazione corrente
      this.layers.filter(this.isLayerWMS).filter(this.isLayerVari).forEach(function (item) {
         if (!item.get('group_id').includes(nuovoLayer.get('group_id'))) {
            item.setVisible(false);
         }
      });

      // Rendo visibile la rappresentazione selezionata + i layer di supporto in base alla tipologia di utente corrente
      nuovoLayer.setVisible(true);
      this.layers.filter(this.isLayerWMS).filter(this.isLayerSupporto).filter(this.filtroTipologiaUtente())
         .forEach(function (item) {
            if (item.get('group_id').includes(nuovoLayer.get('group_id'))) {
               item.setVisible(true);
            }
         });

      this.rappresentazioneAttiva = nuovoLayer;
      // emetto un evento di cambio rappresentazione
      this.eventoGenerico.emit({ chiave: this.CAMBIATA_RAPPRESENTAZIONE, valore: nuovoLayer });
   }

   eliminaRappresentazione() {
      const layer = new VectorLayer({});
      layer.set('group_id', 'Vuoto');
      layer.set('generic_type', 'Temp');
      layer.set('tab', 'Base');
      this.cambiaRappresentazione(layer);
   }


   ottieniFeatures(coordinate) {

      this.http.get('assets/objects.geojson', { observe: 'body', responseType: 'text' }).subscribe(
         (response) => {
            // console.log(response);

            // deve essere un GeoJSON con coordinate in EPSG:3857
            this.disegnaGeoJSONObject(response);
         },
         (err: string) => {
            reject(`Could not load file 'assets/config/objects.geojson': ${JSON.stringify(err)}`);
         }, () => console.log('Completata richiesta HTTP'));
   }

   /**
   * Conversione DEG -> DEC  di una singola coordinata -> TESTATA
   */
   DMStoDD(degrees, minutes, seconds) {
      const deg = parseInt(degrees, 10),
         min = (parseInt(minutes, 10) / 60.0),
         sec = (parseFloat(seconds) / 3600.0),
         decimals = deg + min + sec;
      console.log('DD :-> ', decimals);
      return decimals;
   }

   // Conversione DEC -> DEG di una singola coordinata -> TESTATA
   DDtoDMS(coordindate) {
      const degree = parseInt(coordindate, 10); // prende il decimale in base 10 (radix)
      const minuteDecimal = Math.abs(coordindate - degree) * 60.0;
      const minute = Math.floor(minuteDecimal);
      const secondsDecimal = (minuteDecimal - minute) * 60.0;
      console.log('DMS:-> ', [degree, minute, secondsDecimal]);
      return [degree, minute, secondsDecimal];
   }

   // FILTRI
   filtroTipologiaUtente() {
      return (currentLayer) => {
         return currentLayer.get('user_type').includes(this.tipologiaUtenteCorrente);
      };
   }

   isLayerWMS(currentLayer: BaseLayer) {
      return currentLayer.get('generic_type') === 'WMS';
   }

   isLayerBase(currentLayer: BaseLayer) {
      return currentLayer.get('generic_type') === 'BASE';
   }

   isBaseTab(currentLayer: BaseLayer) {
      return currentLayer.get('tab') === 'Base';
   }

   isAreeTab(currentLayer: BaseLayer) {
      return currentLayer.get('tab') === 'Aree';
   }

   isLayerSupporto(currentLayer: BaseLayer) {
      return currentLayer.get('group_id').includes('supporto');
   }

   isLayerOzionale(currentLayer: BaseLayer) {
      return currentLayer.get('group_id').includes('opzionale');
   }

   isLayerVari(currentLayer: BaseLayer) {
      return currentLayer.get('group_id').includes('vari');
   }

   cambiaVisibilitaLayer(titoloLayer: string, isVisible: boolean) {

      let layer = this.mappa.layers.filter(l => l.getProperties().titolo === titoloLayer)

      // Visibilità prima della modifica
      let visibilityBefore;

      if (layer.length > 0) {
         visibilityBefore = layer[0].getVisible();
         layer[0].setVisible(isVisible)
      }

      return visibilityBefore;
   }

   diminiuisciZoom() {
      this.mappa.diminuisciZoom();
   }

   // Controlla se esiste un layer
   layerExists(layerName: string): boolean {
      const layers = this.mappa?.mappaOpenLayer?.getLayers()?.getArray() || [];
      return layers.some(layer => layer.getProperties().titolo === layerName);
   }


   // Add Vector Layer
   addVectorLayer(layerName, geojsonObject, style, zIndex, zoom = true) {

      // Per stampare i layers
      // this.mappa.mappaOpenLayer.getLayers().getArray().map(l => l.getProperties().titolo)

      this.removeLayer(layerName);

      // Altrimenti creo il layer
      const vectorSource = new VectorSource({
         features: new GeoJSON().readFeatures(geojsonObject, {
            dataProjection: this.EPSG_4326_KEY,
            featureProjection: this.EPSG_3857_KEY
         })
      });

      // TODO personalizza stile
      const newVectorLayer = new VectorLayer({
         zIndex: zIndex,
         visible: true,
         source: vectorSource,
         style: style
      });

      newVectorLayer.set(MapService.TITOLO_LAYER_KEY, layerName)
      newVectorLayer.set(MapService.TIPO_LAYER_KEY, TipoLayer.TEMP);
      newVectorLayer.set(MapService.POSIZIONE_LAYER_KEY, PosizioneLayer.OVERLAY);

      // TODO aspettare che this.mappa?.mappaOpenLayer sia ready (vedi tab analisi)
      if (this.mappa?.mappaOpenLayer) {
         this.mappa.mappaOpenLayer.addLayer(newVectorLayer);

         if (zoom) {
            let extent = vectorSource.getExtent();
            this.mappa.mappaOpenLayer.getView().fit(extent)
         }
      } else {
         console.error("Errore: mappa.mappaOpenLayer non presente")
      }
   }


   zoomToLayer(layerName: string) {
      const layer = this.mappa.mappaOpenLayer
         .getLayers()
         .getArray()
         .find((layer) => layer.get('titolo') === layerName);

      if (layer instanceof VectorLayer) {
         const source = layer.getSource();
         if (source) {
            const extent = source.getExtent();
            this.mappa.mappaOpenLayer.getView().fit(extent)
         } else {
            console.warn('Source non trovato nel layer:', layerName);
         }
      } else {
         console.warn('Layer non vettoriale o non trovato:', layerName);
      }
   }


   // Remove Layer
   removeLayer(layerName) {

      // Per stampare i layers
      // this.mappa.mappaOpenLayer.getLayers().getArray().map(l => l.getProperties().titolo)
      // TODO aspettare che this.mappa?.mappaOpenLayer sia ready
      if (this.mappa?.mappaOpenLayer) {
         let layer = this.mappa.mappaOpenLayer.getLayers().getArray()
            .find(l => l.getProperties().titolo === layerName)

         // Se layer esiste già, lo rimuovo
         if (layer) {
            this.mappa.mappaOpenLayer.removeLayer(layer);
            return;
         }
      } else {
         console.error("Errore: mappa.mappaOpenLayer non presente")
      }
   }


   getViewshedStyleFunction(maxDN: number): (feature: Feature<Polygon>) => Style | null {
      return (feature: Feature<Polygon>) => {
         const dn = feature.get('DN');
         // No Visibilità/ noData/ null
         if (dn <= 0 || dn == null) return null;

         const t = Math.min(dn / maxDN, 1);
         const interpolate = (start: number, end: number, t: number) =>
            Math.round(start + (end - start) * t);

         const colors = [
            [68, 1, 84],    // viola scuro
            [59, 82, 139],  // blu profondo
            [33, 145, 140], // verde-azzurro
            [94, 201, 98],  // verde
            [253, 231, 37], // giallo
         ];

         const segmentCount = colors.length - 1;
         const segmentSize = 1 / segmentCount;
         const segmentIndex = Math.min(Math.floor(t / segmentSize), segmentCount - 1);
         const localT = (t - segmentIndex * segmentSize) / segmentSize;

         const [r1, g1, b1] = colors[segmentIndex];
         const [r2, g2, b2] = colors[segmentIndex + 1];

         const r = interpolate(r1, r2, localT);
         const g = interpolate(g1, g2, localT);
         const b = interpolate(b1, b2, localT);
         const a = 0.9; // leggermente più opaco per stampa/visibilità

         return new Style({
            stroke: new Stroke({
               color: 'rgba(255, 255, 255, 0.2)',
               width: 1,
            }),
            fill: new Fill({
               color: `rgba(${r}, ${g}, ${b}, ${a})`,
            }),
         });
      };
   }

   // Save negative links: True
   // TargetSize > 0 -> C'è Visibilità
   // TargetSize <= 0 -> Non c'è visibilità


   getIntervisibilityStyleFunction(): (feature: Feature<any>) => Style | null {
      return (feature: Feature<any>) => {
         const geometryType = feature.getGeometry()?.getType();

         // Stile per i punti osservatore
         if (geometryType === 'Point') {
            return new Style({
               image: new CircleStyle({
                  radius: 8,
                  fill: new Fill({ color: 'rgba(0, 96, 128, 0.6)' }), // blu petrolio semitrasparente
                  stroke: new Stroke({ color: '#1a1a1a', width: 2 }), // bordo grigio molto scuro
               }),
            });
         }

         // Stile per le linee (visibilità)
         else if (geometryType === 'LineString') {
            const targetSize = feature.get('TargetSize');

            if (targetSize === undefined || targetSize === null || targetSize <= 0) {
               // Linea non visibile: rosso tratteggiato
               return new Style({
                  stroke: new Stroke({
                     color: 'rgba(200, 50, 50, 0.8)', // rosso scuro semitrasparente
                     width: 3,
                     lineDash: [6, 4],
                  }),
               });
            }

            // Linea visibile: verde pieno
            return new Style({
               stroke: new Stroke({
                  color: 'rgba(50, 160, 60, 0.8)', // verde naturale semitrasparente
                  width: 3,
               }),
            });
         }

         // Nessuno stile per geometrie non gestite
         return null;

      };

   }

   // Restituisce la visibilità di un layer
   getVisibility(titoloLayer) {
      const layer = this.mappa.mappaOpenLayer.getLayers().getArray().filter(l => l.getProperties().titolo === titoloLayer)
      return layer[0]?.getVisible() || false;
   }

   // Cambia la visibilità dei layers come quelli usati nel LoS
   changeVisibilityOpenlayersLayer(titoloLayer: string, isVisible: boolean) {

      let layer = this.mappa.mappaOpenLayer.getLayers().getArray().filter(l => l.getProperties().titolo === titoloLayer)

      // Visibilità prima della modifica
      let visibilityBefore;

      if (layer.length > 0) {
         visibilityBefore = layer[0].getVisible();
         layer[0].setVisible(isVisible)
      }

      return visibilityBefore;
   }


   insertOverlay(type) {
      const tooltipElement = document.createElement('div');
      tooltipElement.className = 'custom-tooltip';
      tooltipElement.style.position = 'absolute';
      tooltipElement.style.pointerEvents = 'none';
      tooltipElement.style.display = 'none';
      document.body.appendChild(tooltipElement);

      this.mappa.mappaOpenLayer.on('pointermove', (evt) => {
         const feature = this.mappa.mappaOpenLayer.forEachFeatureAtPixel(evt.pixel, (feat) => feat);
         if (feature) {
            if (type === 'V') {
               const dn = feature.get('DN');
               if (dn !== 0 && dn != null) {
                  // tooltipElement.innerHTML = `DN: ${dn}`;
                  // Digital Number
                  tooltipElement.innerHTML = `Copertura (DN): ${dn}`;
                  tooltipElement.style.display = 'block';

                  const pixel = this.mappa.mappaOpenLayer.getPixelFromCoordinate(evt.coordinate);

                  // Calcola dimensioni tooltip
                  const tooltipWidth = tooltipElement.offsetWidth;
                  const tooltipHeight = tooltipElement.offsetHeight;

                  // Posizione Tooltip
                  tooltipElement.style.left = (pixel[0] - tooltipWidth / 2) + 'px';
                  tooltipElement.style.top = (pixel[1] - tooltipHeight / 3) + 'px';
               } else {
                  tooltipElement.style.display = 'none';
               }
            }
         } else {
            tooltipElement.style.display = 'none';
         }
      });
   }


}